import styled from '@emotion/styled-base';

export const Item = styled(`div`)`
  margin-bottom: 8px;
  position: relative;
  padding-bottom: 0 !important;

  .active {
    &:before {
      color: rgb(26, 188, 156);
    }
  }

  .not-active {
    &:before {
      color: rgb(241, 85, 108);
    }
  }

  .big {
    font-weight: 700;
  }

  .item-contents {
    position: relative;
  }

  .item-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: baseline;
    column-gap: 16px;
    border: none;
    background: transparent;
    padding: 0;
    margin-bottom: 4px;
  }

  .document-title {
    font-size: 13px;
    font-weight: 700;

    i {
      margin-left: 8px;
    }
  }

  .item-body {
    margin-left: 8px;

    p {
      margin: 0 0 4px;
    }
  }

  .children-inner-item {
    margin-left: 10px;
  }
`;
